import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SelectAtomSharedComponent } from './select.component';

@NgModule({
    declarations: [
        SelectAtomSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule
    ],
    exports: [
        SelectAtomSharedComponent
    ]
})

export class SelectAtomSharedModule {}
